// Blob handling lives here and not in the tools: they only hand back bytes.
export function saveBytes(bytes: Uint8Array, filename: string, type = 'application/x-step') {
  const blob = new Blob([bytes as unknown as BlobPart], { type });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
